export const proceeds = {
  items: [
    {
      id: 1,
      invoiceDate: '2022-02-04T00:00:00',
      documentNumber: '6559644',
      documentValue: 12345,
      remainingValue: 34567,
      isOpen: true
    },
    {
      id: 2,
      invoiceDate: '2022-02-04T00:00:00',
      documentNumber: '6559644',
      documentValue: 12345,
      remainingValue: 55555,
      isOpen: true
    },
    {
      id: 3,
      invoiceDate: '2022-02-04T00:00:00',
      documentNumber: '6559644',
      documentValue: 12345,
      remainingValue: 3466567,
      isOpen: false
    },
    {
      id: 4,
      invoiceDate: '2022-02-04T00:00:00',
      documentNumber: '6559644',
      documentValue: 12345,
      remainingValue: 234,
      isOpen: false
    },
    {
      id: 5,
      invoiceDate: '2022-02-04T00:00:00',
      documentNumber: '6559644',
      documentValue: 12345,
      remainingValue: 1
    },
    {
      id: 6,
      invoiceDate: '2022-02-04T00:00:00',
      documentNumber: '6559644',
      documentValue: 12345,
      remainingValue: 0
    }
  ],
  total: 6,
  totalPages: 1
};
